// Clean SVG-style brand wordmarks (no image stretching)

export function BarkWordmark({ className = "h-5" }) {
    // Approximated Bark.com wordmark: white "bark" + small wing swoosh
    return (
        <svg
            viewBox="0 0 120 36"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Bark"
        >
            {/* Wing swoosh */}
            <path
                d="M2 24 L20 12 L18 26 Z M6 30 L20 24 L16 32 Z"
                fill="#ffffff"
            />
            {/* Wordmark */}
            <text
                x="28"
                y="27"
                fontFamily="'Manrope', system-ui, sans-serif"
                fontWeight="800"
                fontSize="26"
                fill="#ffffff"
                letterSpacing="-1"
            >
                bark
            </text>
        </svg>
    );
}

export function TrustpilotWordmark({ className = "h-5" }) {
    // Approximated Trustpilot wordmark with star
    return (
        <svg
            viewBox="0 0 180 36"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Trustpilot"
        >
            {/* Green star */}
            <path
                d="M16 4 L19.5 13 L29 13.5 L21.5 20 L24 29.5 L16 24 L8 29.5 L10.5 20 L3 13.5 L12.5 13 Z"
                fill="#00B67A"
            />
            {/* Wordmark */}
            <text
                x="36"
                y="26"
                fontFamily="'Manrope', system-ui, sans-serif"
                fontWeight="700"
                fontSize="22"
                fill="currentColor"
                letterSpacing="-0.5"
            >
                Trustpilot
            </text>
        </svg>
    );
}